export default function FollowingPage() {
  return (
    <section>
      <h1>Following</h1>
    </section>
  );
}
